import { Slider, Typography, withStyles } from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import FilterComponent from "./FilterComponent";

const PrettoSlider = withStyles({
  root: {
    color: "#52af77",
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

export default function MinMaxSlider({ title, range, onChange = () => {} }) {
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (!value && range[1] - range[0] > 0) {
      setValue(range);
    }
  }, [range, value]);

  const onSlideChange = useCallback(
    (_evt, newMinAndMax) => {
      onChange({ title, minAndMax: newMinAndMax });
      setValue(newMinAndMax);
    },
    [title, onChange]
  );

  return (
    <FilterComponent>
      <Typography>{title}</Typography>
      <PrettoSlider
        style={{ width: "88%" }}
        onChange={onSlideChange}
        valueLabelDisplay="auto"
        aria-labelledby="range-slider"
        value={value}
        min={range[0] ?? 0}
        max={range[1] ?? 0}
      />
    </FilterComponent>
  );
}
